import type { StartWeek } from '../types/StartWeek';
import { START_WEEK } from '../constants';

export class WeekDays {
  protected startWeek: StartWeek;

  protected days: string[] = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];

  protected shortDays: string[] = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  public constructor(startWeek: StartWeek) {
    this.startWeek = startWeek;
  }

  public getDayOfWeek(date: Date): string {
    return this.days[date.getDay()];
  }

  public getIndexStartWeekDay(): number {
    return this.days.indexOf(this.startWeek);
  }

  /**
   * Метод возвращает количество дней, от начала недели до переданного дня
   */
  public getPosition(day: number): number {
    day = this.startWeek === START_WEEK.MONDAY ? day - 1 : day;

    return day < 0 ? 6 : day;
  }

  public getHeaderDays(): string[] {
    if (this.startWeek === START_WEEK.MONDAY) {
      const week = this.shortDays.slice(1, this.shortDays.length);
      week.push(this.shortDays[0]);
      return week;
    }

    return this.shortDays;
  }
}
